import React from 'react';
var SelectContext = React.createContext({
  value: '',
  onClick: function onClick() {},
  isOpen: false
});
export default SelectContext;